let _timer = null;
let _logs = [];
let _forces = [];

export default {
  log(msg, force) {
    console.log(msg);

    if (force) {
      _forces.push({
        time: new Date().toLocaleString(),
        log: msg || '',
      });
    } else {
      _logs.push({
        time: new Date().toLocaleString(),
        log: msg || '',
      });
    }

    if (!_timer) {
      _timer = setTimeout(_ => {
        this.post();
        this.force();

        _timer = null;

        _logs = [];
        _forces = [];
      }, 4000);
    }
  },

  post() {
    if (_logs.length === 0) return;

    let xmlhttp = new XMLHttpRequest();

    xmlhttp.open('POST', location.protocol + '//h5.qzone.qq.com/log/post/uploaderWebApp');
    xmlhttp.setRequestHeader('Content-Type', 'application/json');
    xmlhttp.send(JSON.stringify(_logs, null, 4));
  },

  force() {
    if (_forces.length === 0) return;

    new Image().src =
      location.protocol +
      '//h5.qzone.qq.com/log/post/uploaderWebAppForce?uin=382310210&' +
      encodeURIComponent(JSON.stringify(_forces, null, 4));
  },
};
